/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-literals */
import React, { Component } from "react";

import PropTypes from "prop-types";
// import { observer } from "mobx-react";
import { generate } from "shortid";

import "./StatsPreview.scss";
import { PieChart, Bars as DefaultBars } from "../..";
// import { BASKETBALL } from "../../utils/constants";
import noStatsBars from "../../assets/imgs/no-stats-bars.svg";
// import I18N from "../../I18N";

const NoStatsBars = () => (
  <div className="no-stats-bars">
    <img src={noStatsBars} alt="" />
    <div className="no-stats-bars__text">
      <span>There are</span>{" "}
      <span className="no-stats-bars__text--green">
        no stats yet
      </span>
    </div>
  </div>
);

// eslint-disable-next-line react/require-optimization
class Bars extends Component {
  state = {
    uniqueId: generate()
  };

  shouldComponentUpdate() {
    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        uniqueId: generate()
      });
    }
  }

  render() {
    const { data, isStats } = this.props;
    const { uniqueId } = this.state;

    if (!isStats) {
      return <NoStatsBars />;
    }

    /* eslint-disable no-unused-expressions */
    return data ? (
      <DefaultBars data={data} uniqueId={uniqueId} isVertical />
    ) : null;
  }
}

/* eslint-disable no-param-reassign */
function Stats({
  bars,
  donuts,
  isStats,
  isLastGameStats,
  isPlayerProfile,
  pointsPerGame,
  sportsCategory, 
  isSeasonAvg
}) {
  const pieStatsType = isPlayerProfile || isSeasonAvg ? "avg" : "count";
  const barsStatsType = isPlayerProfile || isSeasonAvg ? "avg" : "current";
  if (bars && !bars.data) {
    bars = bars
      ? Object.keys(bars).map(key => ({
          data: [bars[key][barsStatsType]],
          tag: bars[key].tag
        }))
      : null;
  }

  return (
    <div
      className={`stats-preview ${
        isLastGameStats ? "stats-preview--last-game" : ""
      }`}
    >
      {isLastGameStats ? (
        <h2 className="stats-preview__title">
          <div>
            Last Game
            <span className="stats-preview__title__sub">Stats</span>
          </div>
        </h2>
      ) : null}
      {pointsPerGame && sportsCategory === "basketball" ? (
        <div className="stats-preview__points">
          <h2 className="stats-preview__points__title">
            Points Per Game
          </h2>
          <span className="stats-preview__points__number">{pointsPerGame}</span>
        </div>
      ) : null}
      <div className="stats-preview__stats">
        <div className="stats-preview__donuts">
          {donuts &&
            Object.values(donuts).map((donut, i) => (
              <PieChart
                key={
                  donut.failure.count +
                  donut.success.count +
                  donut.failure.avg +
                  donut.success.avg +
                  donut.success.tag
                }
                pieIndex={i}
                failure={donut.failure[pieStatsType]}
                success={donut.success[pieStatsType]}
                hasTooltip={false}
                parameter={donut.success.tag}
              />
            ))}
        </div>
        <div className="stats-preview__bars">
          <Bars data={bars} isStats={isStats} hasBackgroundLines />
        </div>
      </div>
    </div>
  );
}

Bars.propTypes = {
  data: PropTypes.shape(),
  isStats: PropTypes.bool
};

Bars.defaultProps = {
  data: {},
  isStats: false
};

Stats.propTypes = {
  bars: PropTypes.shape(),
  donuts: PropTypes.shape(),
  isLastGameStats: PropTypes.bool,
  isPlayerProfile: PropTypes.bool,
  isStats: PropTypes.bool,
  pointsPerGame: PropTypes.number,
  sportsCategory: PropTypes.string
};

Stats.defaultProps = {
  bars: {},
  donuts: {},
  isLastGameStats: false,
  isPlayerProfile: false,
  isStats: true,
  pointsPerGame: 0,
  sportsCategory: ""
};

export default Stats;
